import { render, staticRenderFns } from "./SurveyTemplatesPage.vue?vue&type=template&id=dea4a35c&scoped=true"
import script from "./SurveyTemplatesPage.vue?vue&type=script&lang=js"
export * from "./SurveyTemplatesPage.vue?vue&type=script&lang=js"
import style0 from "./SurveyTemplatesPage.vue?vue&type=style&index=0&id=dea4a35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea4a35c",
  null
  
)

export default component.exports